import React, { useEffect } from 'react';
import { Link, RouteComponentProps } from 'react-router-dom';
import { Button, Row, Col } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { getEntity } from './sensor.reducer';
import { APP_DATE_FORMAT, APP_LOCAL_DATE_FORMAT } from 'app/config/constants';
import { useAppDispatch, useAppSelector } from 'app/config/store';
import DoNotShowInProduction from 'app/shared/components/do-not-show-in-production/do-not-show-in-production.component';

export const SensorDetail = (props: RouteComponentProps<{ id: string }>) => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(getEntity(props.match.params.id));
  }, []);

  const sensorEntity = useAppSelector(state => state.sensor.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="sensorDetailsHeading">
          <Translate contentKey="fleetSenseApp.sensor.detail.title">Sensor</Translate>
        </h2>
        <dl className="jh-entity-details">
          <DoNotShowInProduction>
            <dt>
              <span id="id">
                <Translate contentKey="global.field.id">ID</Translate>
              </span>
            </dt>
          <dd>{sensorEntity.id}</dd>
          </DoNotShowInProduction>
          <dt>
            <span id="name">
              <Translate contentKey="fleetSenseApp.sensor.name">Name</Translate>
            </span>
          </dt>
          <dd>{sensorEntity.name}</dd>
          <dt>
            <span id="description">
              <Translate contentKey="fleetSenseApp.sensor.description">Description</Translate>
            </span>
          </dt>
          <dd>{sensorEntity.description}</dd>
          <dt>
            <span id="unit">
              <Translate contentKey="fleetSenseApp.sensor.unit">Unit</Translate>
            </span>
          </dt>
          <dd>{sensorEntity.unit}</dd>
          <dt>
            <span id="sensorConsolidatedMethod">
              <Translate contentKey="fleetSenseApp.sensor.sensorConsolidatedMethod">Sensor Consolidated Method</Translate>
            </span>
          </dt>
          <dd>{sensorEntity.sensorConsolidatedMethod}</dd>
        </dl>
        <Button onClick={() => props.history.goBack()} replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/sensor/${sensorEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default SensorDetail;
